<div
  class="live-template flex flex-column align-items-center justify-content-center">
  @switch (currentStep$ | async) {
    @case ('CHAT') {
      <div class="h-full w-full">
        <app-chat-box
          [currentUser]="currentUser"
          (emitTotalUnread)="emitUnreadMsg($event)"></app-chat-box>
      </div>
    }
    @case ('RETRY') {
      <div
        class="default-template flex flex-column align-items-center justify-content-center gap-2 mb-5">
        <div class="flex flex-column align-items-center gap-2 mb-2 w-full">
          <div>
            <svg-icon class="icon-info" key="nonSupport" size="xxl"></svg-icon>
          </div>
          <div>No agents are available</div>
          <div class="text-center">
            Please write your message to the support team, and they will respond
            to you as soon as possible.
          </div>
        </div>
        <div class="w-full">
          <textarea
            pTextarea
            placeholder="Your message"
            class="fixed-textarea custom-p-input"
            [rows]="6"
            maxlength="2000"
            TextInputValidate
            [autoResize]="false"
            [(ngModel)]="newMessageText"
            (keydown.enter)="handleEnterKey($event)"></textarea>
        </div>
        <div class="w-full">
          <div class="step-button step-button--primary" (click)="onSend()">
            Send
          </div>
        </div>
      </div>
    }
    @case ('WAIT') {
      <div class="flex flex-column gap-3">
        <div class="dot-container">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
        <div>An agent is on the way</div>
      </div>
    }
    @default {
      <div></div>
    }
  }
</div>
